// extracted by mini-css-extract-plugin
module.exports = {"izvjestaji":"Izvjestaji_izvjestaji__31oJw"};